import { PdfTable } from 'pages/v2/compiler/PDF/Styles.styled';
import React from 'react';
import { ScenarioModuleReadModel } from 'types/types';

interface ScenarioModuleDescriptionPdfProps {
  module: string;
  moduleName: string;
  isDefaultScenario: boolean;
  scenarioModule: ScenarioModuleReadModel | undefined;
  isEPDComplete?: boolean;
}

const ScenarioModuleDescriptionPdf: React.FC<ScenarioModuleDescriptionPdfProps> = ({
  module,
  moduleName,
  isDefaultScenario,
  scenarioModule,
  isEPDComplete,
}) => {
  const defaultScenarioModuleBriefDescription = scenarioModule?.defaultScenarioModuleBriefDescription;
  const defaultScenarioModuleDescription = scenarioModule?.defaultScenarioModuleDescription;
  const filledRows = scenarioModule?.scenarioModuleItems?.filter((x) => x.unitId && x.value && x.description);

  const isEmpty = (value: string | undefined | null) => {
    return value === null || value === undefined || value.trim() === '';
  };

  const hideRSLDescription =
    filledRows?.length === scenarioModule?.scenarioModuleItems.length &&
    isEmpty(scenarioModule?.defaultScenarioModuleDescription) &&
    module === 'RSL';

  const bothDescriptionsEmpty =
    !isEPDComplete && isEmpty(defaultScenarioModuleBriefDescription) && isEmpty(defaultScenarioModuleDescription);

  const shouldShowDefaultScenarioModuleBriefDescription =
    bothDescriptionsEmpty || (!isEmpty(defaultScenarioModuleBriefDescription) && isEmpty(defaultScenarioModuleDescription));

  const shouldShowDefaultScenarioModuleDescription =
    (bothDescriptionsEmpty && isDefaultScenario) || !isEmpty(defaultScenarioModuleDescription);

  const shouldShowExplanatoryNameOrBriefDescription = isDefaultScenario && module !== 'RSL';

  const shouldRenderTable =
    shouldShowExplanatoryNameOrBriefDescription ||
    shouldShowDefaultScenarioModuleDescription ||
    shouldShowExplanatoryNameOrBriefDescription;

  if (!shouldRenderTable) {
    return null;
  }

  return (
    <PdfTable style={{ marginBottom: 15 }}>
      <thead>
        <tr>
          <th style={{ width: '30%' }}></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {shouldShowExplanatoryNameOrBriefDescription && (
          <>
            <tr>
              <td style={{ fontSize: '12px', padding: '15px' }}>
                Explanatory name of the default scenario in module {moduleName}
              </td>
              <td style={{ fontSize: '12px', padding: '15px' }}>{scenarioModule?.defaultScenarioModuleExplanatoryName}</td>
            </tr>
            {shouldShowDefaultScenarioModuleBriefDescription && (
              <tr>
                <td style={{ fontSize: '12px', padding: '15px' }}>
                  Brief description of the default scenario in module {moduleName}
                </td>
                <td style={{ fontSize: '12px', padding: '15px' }}>
                  {scenarioModule?.defaultScenarioModuleBriefDescription}
                </td>
              </tr>
            )}
          </>
        )}

        {shouldShowDefaultScenarioModuleDescription && !hideRSLDescription && (
          <tr>
            <td style={{ fontSize: '12px', padding: '15px' }}>
              Description of the {isDefaultScenario ? 'default' : 'additional'} scenario in
              {module === 'RSL' ? ' reference service life' : ` module ${moduleName}`}
            </td>
            <td style={{ fontSize: '12px', padding: '15px' }}>{scenarioModule?.defaultScenarioModuleDescription}</td>
          </tr>
        )}
      </tbody>
    </PdfTable>
  );
};

export default ScenarioModuleDescriptionPdf;
